export interface Pagination {
  pageNumber: number;
  pageSize: number;
}

export const DEFAULT_PAGINATION: Pagination = { pageNumber: 1, pageSize: 10 };
